/*!
 *
 * jQuery collageCaption Plugin v0.1.1
 * extra for collagePlus plugin
 * https://github.com/ed-lea/jquery-collagePlus
 *
 * Copyright 2012, Ed Lea twitter.com/ed_lea
 *
 * built for http://qiip.me
 *
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.opensource.org/licenses/GPL-2.0
 *
 */
(function(a){a.fn.collageCaption=function(b){var d={images:a(this).children(),opacity:"0.5",speed:400,cssClass:"thumb-over"};
var c=a.extend({},d,b);return this.each(function(){var e=0,f=[];c.images.each(function(k){var p=a(this);if(typeof p.data("caption")=="undefined"){return;
}if(typeof p.data("description")=="undefined"){return;}var j='<div class="'+c.cssClass+'" style="width:'+p.find("img").width()+"px; height:"+p.find("img").height()+'px;"><div class="over-pattern" style="opacity:'+c.opacity+';"></div><div class="btn-view-full"></div><div class="thumb-caption"><span class="thumb-title">'+p.data("caption")+'</span><span class="thumb-subtitle">'+p.data("description")+"</span></div></div>";
p.append(j);var l=p.find("."+c.cssClass),m=p.find(".over-pattern"),h=p.find(".thumb-caption");var g=l.height();p.bind({mouseenter:function(i){l.animate({top:0},{duration:c.speed/2,queue:false});
$(this).find(".btn-view-full").stop();$(this).find(".btn-view-full").animate({top:"50%"},{duration:100});},mouseleave:function(i){l.animate({top:"100%"},{duration:c.speed,queue:false});
$(this).find(".btn-view-full").stop();$(this).find(".btn-view-full").animate({top:"30%"},{duration:100});}});});return this;});};})(jQuery);